<template>
  <zm-drawer
    ref="drawer"
    :title="title"
    :width="drawerWidth"
    :visible="visible"
    :footer="false"
    @cancel="open(false)"
  >
    <div slot="drawerBody" class="edit-person">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名" required>
              <a-input
                autocomplete="off"
                disabled
                v-model="model.userName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别" required>
              <a-input
                autocomplete="off"
                disabled
                v-model="model.genderName"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="员工编号" required>
              <a-input
                autocomplete="off"
                disabled
                v-model="model.userNumber"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属部门" required>
              <a-input
                autocomplete="off"
                disabled
                v-model="model.deptName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="职位" required>
              <a-input
                autocomplete="off"
                disabled
                v-model="model.departmentJobStr"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门主管">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.headName"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="人员角色">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.roleNames"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在岗类型">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.jobStatusDesc"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入职日期">
              <a-date-picker
                style="width: 100%"
                disabled
                v-model="model.entryDateM"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="转正日期">
              <a-date-picker
                style="width: 100%"
                disabled
                v-model="model.formallyDateM"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="毕业院校">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.school"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最高学历">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.educationName"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="身份证">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.identityNum"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="籍贯">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.birthPlace"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.tel"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.email"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="婚姻状况">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.maritalStatusName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="政治面貌">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.politicalStatusName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="现住址">
              <a-input
                autocomplete="off"
                disabled
                v-model="model.address"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="简历附件">
              <zm-preview
                :list="fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/user/file/down/"
              ></zm-preview>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="初评附件">
              <zm-preview
                :list="scoreFileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/user/file/down/"
              ></zm-preview>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="offer附件">
              <zm-preview
                :list="offerFileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/user/file/down/"
              ></zm-preview>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="备注">
              <a-textarea
                disabled
                :rows="3"
                v-model="model.remarks"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'BaseInfoModal',
  computed: {
    ...mapGetters(['selectedDept']),
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    }
  },
  data () {
    return {
      title: null,
      width: 900,
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'baseInfo_form' }),
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 22 }
      },
      colSpan: 6,
      model: {},
      type: 'MODAL_ADD', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      genderList: [
        { value: 1, label: '男' },
        { value: 2, label: '女' }
      ],
      deptList: [],
      internshipList: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      educationList: [],
      platformList: [],
      userList: [],
      jobStatusList: [
        { value: 1, label: '正式' },
        { value: 2, label: '试用' },
        { value: 3, label: '实习' }
      ],
      roleList: [],
      politicalList: [],
      areaList: [],
      maritalStatusList: [
        { value: 1, label: '已婚' },
        { value: 0, label: '未婚' }
      ],
      jobList: [],

      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: [],
      scoreFileList: [],
      offerFileList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      console.log('组织id', this.selectedDept)
      if (flag) {
        this.getModelInfo()
      }
    },
    // 获取当前的model详情
    getModelInfo () {
      this.$nextTick(() => {
        // 岗位类型
        let jobStatusDesc
        switch (this.model.jobStatus) {
          case 1:
            jobStatusDesc = '正式'
            break
          case 2:
            jobStatusDesc = '试用'
            break
          case 3:
            jobStatusDesc = '实习'
            break
          default:
            jobStatusDesc = ''
            break
        }
        this.$set(this.model, 'jobStatusDesc', jobStatusDesc)

        // 籍贯
        const birthPlace = []
        if (this.model.provinceName) {
          birthPlace.push(this.model.provinceName)
          if (this.model.cityName) {
            birthPlace.push(this.model.cityName)
            if (this.model.districtName) birthPlace.push(this.model.districtName)
          }
        }
        this.$set(this.model, 'birthPlace', birthPlace.join(','))
        
        if (this.model.entryDate) this.$set(this.model, 'entryDateM', moment(this.model.entryDate))
        if (this.model.formallyDate) this.$set(this.model, 'formallyDateM', moment(this.model.formallyDate))
        console.log('model', this.model)

        this.fileList = this.model.fileList.filter(file => file.fileType === 1)
        this.scoreFileList = this.model.fileList.filter(file => file.fileType === 2)
        this.offerFileList = this.model.fileList.filter(file => file.fileType === 3)
      })
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
      this.fileList = []
      this.scoreFileList = []
      this.offerFileList = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
  }
}
</script>

<style scoped></style>
